import React, { forwardRef, useEffect, useRef, useState } from 'react';
import Edenred from './Edenred/Edenred';
import { selectPayment } from '../actions/payMethodActions';
import { useDispatch, useSelector } from 'react-redux';
import PaygreenConecs from './Paygreen/PaygreenConecs';
import goback_arrow from '../styles/img/goback_arrow.svg';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { checkButton } from './checkButton.js';
import { formatPriceWithEuro } from '../utils/StringUtils';
import { PositionDetector } from '../utils/DrawerPositionDetector.jsx';
import CreditCard from './Stripe/CreditCard';
import PayzenCreditCard from './Payzen/PayzenCreditCard';
import { isTRavailable } from '../utils/Validator';
import infoSvg from '../styles/img/info.svg';
import errorApplepayTRlogo from '../styles/img/account/passwordLogo.svg';
import PrimaryButton from '../components/button/PrimaryButton';
import closeArrow from '../styles/img/account/closeArrow.svg';
import WrongPaymentMethod from '../components/tile/WrongPaymentMethod';
import PayzenPayments from './Payzen/PayzenPayments';
import PaygreenSwile from './Paygreen/swile/PaygreenSwile';
import { useOrderLogger } from '../hooks/useOrderLogger';
import PaymentLoader from '../components/loader/PaymentLoader.jsx';
import { calculateTotalToPay } from '../utils/order/orderUtils';

const PopupPayment = (
  {
    open,
    openStatus,
    order,
    store,
    axiosInstance,
    edBalance,
    conecsBalance,
    cb,
    paymentErrorMessage,
    setPaymentErrorMessage,
    edenredErrorMessage,
    setEdenredErrorMessage,
    edenredIsLoading,
    isPayzenModule,
    promoLoaded,
    setPayzenToken,
    onSheetReady
  },
  ref,
) => {
  const [loading, setLoading] = useState(false);
  const { logPaymentMethodChanged } = useOrderLogger();
  const dispatch = useDispatch();
  const [checkedCB, setCheckedCB] = useState('');
  const { googlePayPayzenLoading } =
    useSelector((state) => state.cart);
  const [payMethod, setPayMethod] = useState(undefined);
  const [isPaid, setIsPaid] = useState(false);
  const [applepayTRpopup, setApplepayTRpopup] = useState(false);
  const user = useSelector((state) => state.user);
  const targetNode = document.getElementById('spring-bottom-popuppayment');
  const [isPopupShadow, setIsPopupShadow] = useState(false);
  const [isSheetReady, setIsSheetReady] = useState(false);


  useEffect(() => {
    PositionDetector(targetNode, setIsPopupShadow, store, order);
  }, [targetNode]);

  const refComposant1 = useRef();
  const refComposant2 = useRef();
  const refComposant3 = useRef();
  const refComposant4 = useRef();

  const bottomSheetRef = useRef(null);

  // const selectCbPaymentMode = isPayzenModule
  //   ? user.payzenCreditCards && user.payzenCreditCards[0]?.last4
  //   : user.creditCard && user.creditCard[0]?.last4;

  // useEffect(() => {
  //   // TODO : ajouter dans le composant parent
  //   if (selectCbPaymentMode) {
  //     handleCheckboxChange("cb");
  //   } else if (user.conecs?.buyerId) {
  //     handleCheckboxChange("conecs");
  //   } else if (user.edenredInfo && user.edenredInfo.balance) {
  //     handleCheckboxChange("edenred");
  //   }
  // }, []);

  // useEffect(() => {
  //   if (checkedCB.includes("cb")) {
  //     setIsCBContentVisible(true);
  //     setValidBtn(!!cbForm);
  //   } else if (checkedCB.includes("conecs")) {
  //     setIsTRContentVisible(true);
  //     setValidBtn(!!cbForm);
  //   } else {
  //     setValidBtn(true);
  //     setIsCBContentVisible(false);
  //     setIsTRContentVisible(false);
  //   }
  //   cb(checkedCB);
  // }, [checkedCB]);

  // useEffect(() => {
  //   if (checkedCB.includes('cb')) {
  //     setValidBtn(!!cbForm);
  //   } else {
  //     setIsCBContentVisible(false);
  //   }
  // }, [cbForm]);

  const handleChange = (id) => {
    // setCheckedCB((prevCheckedId) => (prevCheckedId === id ? "" : id));
  };

  const handleBalance = (balanceEvent) => {
    edBalance(balanceEvent);
  };

  const resetPaymentMethod = () => {
    setPayMethod(undefined);
  };

  const handleCheckboxChange = (paymentMethod) => {
    logPaymentMethodChanged(order?._id, order?.userId, paymentMethod);

    const updatePaymentMethod = (method) => {
      resetPaymentMethod();
      setTimeout(() => {
        setPayMethod(method);
      }, 100);
    };

    if (payMethod === paymentMethod) {
      resetPaymentMethod();
    } else if (paymentMethod === 'conecs') {
      updatePaymentMethod('conecs');
    } else if (paymentMethod === 'swile') {
      updatePaymentMethod('swile');
    } else if (paymentMethod === 'cb') {
      updatePaymentMethod('cb');
    } else {
      updatePaymentMethod('edenred');
    }

    dispatch(selectPayment(paymentMethod));
  };

  const startLoading = () => {
    setLoading(true);
    setPaymentErrorMessage('');
    setEdenredErrorMessage('');
  };

  const errorMessage = (event) => {
    setPaymentErrorMessage(event);
    setLoading(false);
  };

  const test = async () => {
    if (payMethod && payMethod.length > 0) {
      switch (payMethod) {
        case 'cb':
          startLoading();
          try {
            await refComposant1.current.handleSubmit();
          } catch (e) {
            console.error(e);
            setLoading(false);
          }
          break;
        case 'conecs':
          startLoading();
          try {
            if (store?.paymentsGateway?.TR === 'payzen')
              await refComposant1.current.handleSubmit();
            else await refComposant2.current.handleSubmitPaygreen(order);
          } catch (e) {
            setLoading(false);
          }
          break;
        case 'edenred':
          startLoading();
          try {
            await refComposant3.current.handleSubmit(order);
          } catch (e) {
            setLoading(false);
          }

          break;
        default:
          alert('Pas de méhode de paiement choisie');
      }
    }
  };
  useEffect(() => {
    console.log('payMethod', payMethod);
    if (
      user?.creditCard &&
      user?.creditCard?.[0]?.pm &&
      user?.creditCard?.[0]?.pm?.length > 0 &&
      payMethod == undefined &&
      !isPayzenModule
    ) {
      setPayMethod('cb');
    } else if (
      user?.payzenCreditCards &&
      user?.payzenCreditCards?.[0]?.pm &&
      user.payzenCreditCards?.[0]?.pm?.length > 0 &&
      payMethod == undefined &&
      isPayzenModule
    ) {
      setPayMethod('cb');
    }
  }, []);

  useEffect(() => {
    if (openStatus && bottomSheetRef && isSheetReady && bottomSheetRef.current) {
        bottomSheetRef.current.snapTo(1000);
    }
  }, [openStatus, isSheetReady]);

  const hasActivePayzenCard =
    isPayzenModule &&
    payMethod === 'cb' &&
    user.payzenCreditCards &&
    Object.keys(user.payzenCreditCards).length &&
    user.payzenCreditCards[0]?.pm &&
    user.payzenCreditCards[0].pm.length > 0;
  const hasActivePayzenConecsCard =
    isPayzenModule &&
    payMethod === 'conecs' &&
    user.payzenConecsCreditCards &&
    Object.keys(user.payzenConecsCreditCards).length &&
    user.payzenConecsCreditCards[0]?.pm &&
    user.payzenConecsCreditCards[0].pm.length > 0;
  const hasActiveStripeCard =
    !isPayzenModule &&
    user.creditCard &&
    Object.keys(user.creditCard).length &&
    user.creditCard[0]?.pm &&
    user.creditCard[0].pm.length > 0;
  const hasActiveCard = hasActivePayzenCard || hasActiveStripeCard;
  const hasActiveConecs =
    (user.conecs && Object.keys(user.conecs).length > 0) ||
    hasActivePayzenConecsCard;
  const hasActiveEdenred = user.edenred && Object.keys(user.edenred).length > 0;
  const footerElement =
    (hasActiveCard || hasActiveConecs || hasActiveEdenred) &&
    checkButton(payMethod, user, isPayzenModule, store) &&
    !isPaid ? (
      <div>
        {paymentErrorMessage && (
          <div className="payment-error footer">{paymentErrorMessage}</div>
        )}
        <button
          disabled={loading || !payMethod || !payMethod.length > 0}
          onClick={test}
          className={`pt-10 shadow-none w-[100%] py-10 z-4 h-10 rounded-[10px] ${
            payMethod && payMethod.length > 0 ? 'pikko-btn' : 'grayscale'
          }`}
        >
          {loading ? (
            <p>Chargement...</p>
          ) : (
            <div className="flex w-full justify-between px-8 text-[1.7rem]">
              <p>Payer maintenant</p>
              <p>{formatPriceWithEuro(calculateTotalToPay(order.itemsPrice, order.promoPrice, order?.jackpot?.amount))}</p>
            </div>
          )}
        </button>
      </div>
    ) : undefined;
  const handleWrongPaymentMethod = () => {
    open(true);
    setApplepayTRpopup(false);
  };
  return (
    <>
      {applepayTRpopup && (
        <WrongPaymentMethod
          onClose={() => setApplepayTRpopup(false)}
          onClickPrimary={() => handleWrongPaymentMethod()}
        />
      )}
      <BottomSheet
        ref={bottomSheetRef}
        open={true}
        onDismiss={() => {
          if (!googlePayPayzenLoading) {
            open(false);
            bottomSheetRef.current.snapTo(0);
          }
        }}
        onSpringEnd={() => {
          if (!isSheetReady) {
            setIsSheetReady(true);
            onSheetReady?.(true);
          }
        }}
        snapPoints={({ maxHeight }) =>
          store.name.toUpperCase().includes('MATCH')
            ? [maxHeight - maxHeight + 1, maxHeight * 0.85]
            : [maxHeight - maxHeight + 1, maxHeight * 0.75]
        }
        draggable={!googlePayPayzenLoading}
        blocking={isPopupShadow && !googlePayPayzenLoading}
        id="spring-bottom-popuppayment"
        scrollLocking={false}
        className="payment-slider"
        footer={footerElement}
      >
        {googlePayPayzenLoading && (
          <PaymentLoader title="Attente de validation de paiement" />
        )}
        <div>
          <div
            id="paymentPopup"
            className={
              'paymentPopup z-50 $ rounded-tr-[30px] rounded-tl-[30px] py-16 pt-8 flex flex-col'
            }
          >
            <div className="payment-popup-content">
              <div
                className="flex items-center titre_popup "
                onClick={() => {
                  bottomSheetRef.current.snapTo(0);
                  open(false);
                }}
              >
                <span>Méthode de paiement</span>
                <div id="close-popup-cb" className="closepopup2">
                  <img src={goback_arrow} alt="" srcSet="" />
                </div>
              </div>
              <div className="w-full ">
                <>
                  <div id="paymentTab">
                    <div className="w-full mt-8">
                      {isPayzenModule ? (
                        <>
                          {!(store?.paymentsGateway?.TR === 'payzen') ||
                          !isTRavailable(order.orderItems) ? (
                            <PayzenCreditCard
                              onCheckboxChange={() =>
                                handleCheckboxChange('cb')
                              }
                              paymentMethod={payMethod}
                              errorMessage={errorMessage}
                              resetPaymentMethod={resetPaymentMethod}
                              ref={refComposant1}
                              order={order}
                              promoLoaded={promoLoaded}
                              setPayzenToken={setPayzenToken}
                              setTRpopup={() => setApplepayTRpopup(true)}
                            />
                          ) : null}
                        </>
                      ) : (
                        <CreditCard
                          order={order}
                          axiosInstance={axiosInstance}
                          onCheckboxChange={() => handleCheckboxChange('cb')}
                          resetPaymentMethod={resetPaymentMethod}
                          paymentMethod={payMethod}
                          ref={refComposant1}
                          stopPaymentLoading={() => setLoading(false)}
                          paymentErrorMessage={paymentErrorMessage}
                          setPaymentErrorMessage={setPaymentErrorMessage}
                          setIsPaid={setIsPaid}
                        />
                      )}
                    </div>
                  </div>
                </>
                {isTRavailable(order.orderItems) ? (
                  <>
                    {/*{store && store?.TR_CONECS && (*/}
                    <div id="paymentTab" className="">
                      {store?.paymentsGateway?.TR === 'payzen' ? (
                        <PayzenPayments
                          setApplepayTRpopup={setApplepayTRpopup}
                          errorMessage={errorMessage}
                          order={order}
                          resetPaymentMethod={resetPaymentMethod}
                          promoLoaded={promoLoaded}
                          setPayzenToken={setPayzenToken}
                          onCheckboxChange={handleCheckboxChange}
                          paymentMethod={payMethod}
                          ref={refComposant1}
                        />
                      ) : (
                        <PaygreenConecs
                          onCheckboxChange={() =>
                            handleCheckboxChange('conecs')
                          }
                          ref={refComposant2}
                          order={order}
                          paymentMethod={payMethod}
                          stopPaymentLoading={() => setLoading(false)}
                          setPaymentErrorMessage={setPaymentErrorMessage}
                          store={store}
                        />
                      )}
                    </div>
                    <div id="paymentTab" className="">
                      {store?.paymentsGateway?.SWILE === 'paygreen' && (
                        <PaygreenSwile
                          onCheckboxChange={() =>
                            handleCheckboxChange('swile')
                          }
                          ref={refComposant2}
                          order={order}
                          usedPaymentMethod={payMethod}
                          paymentMethod="swile"
                          stopPaymentLoading={() => setLoading(false)}
                          setPaymentErrorMessage={setPaymentErrorMessage}
                          store={store}
                          user={user}

                        />
                      )}
                    </div>
                    <div id="paymentTab">
                      {((store?.paymentsGateway?.TR === 'payzen' && calculateTotalToPay(order.itemsPrice, order.promoPrice, order?.jackpot?.amount) >= 1.5)
                        || store?.paymentsGateway?.TR === 'conecs') && (
                        <>
                          <Edenred
                            balance={handleBalance}
                            onChange={handleChange}
                            order={order}
                            onCheckboxChange={() =>
                              handleCheckboxChange('edenred')
                            }
                            resetPaymentMethod={resetPaymentMethod}
                            paymentMethod={payMethod}
                            ref={refComposant3}
                            stopPaymentLoading={() => setLoading(false)}
                            setEdenredErrorMessage={setEdenredErrorMessage}
                            edenredIsLoading={edenredIsLoading}
                            setIsPaid={setIsPaid}
                            store={store}
                          />
                          <div className="payment-error">
                            {edenredErrorMessage}
                          </div>
                        </>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    {store?.TR_CONECS && store?.TR_EDENRED && (
                      <div className="no-eligible">
                        <img src={infoSvg} alt="" srcSet="" />
                        Certains articles ne sont pas éligibles aux cartes ticket restaurant
                      </div>
                    )}
                  </>
                )}
                {(!store?.TR_CONECS || !store?.TR_EDENRED) && (
                  <div className="no-eligible">
                    <img src={infoSvg} alt="" srcSet="" />
                    Cartes ticket restaurant bientôt disponibles ...
                  </div>
                )}
                {store?.TR_CONECS && store?.TR_EDENRED && calculateTotalToPay(order.itemsPrice, order.promoPrice, order?.jackpot?.amount) < 1.5 &&
                  store?.paymentsGateway?.TR === 'payzen' && (
                    <div className="no-eligible">
                      <img src={infoSvg} alt="" srcSet="" />
                      Montant inférieur à 1,50€ - Panier non éligible aux cartes ticket restaurant
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};
export default forwardRef(PopupPayment);
